import React, { useEffect } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import './index.css';

function PlanTextComponent({
  plan = '',
  updatePlanText = () => {},
  clearField = () => {},
  isDisabled = false,
}) {

  function handleOnchange (e) {
    e.preventDefault();
    
    updatePlanText(e);
  }

  function handleClear (name) {
    clearField(name);
  }
  
  useEffect(() => {
    return () => {}
  }, []);

  return (
    <div className="card custom-card">
      <h5 className="card-header ">Plan</h5>
      <div className="card-body" style={{ padding: '10px' }}>
        <div className="custom-form-group-container txt-clr" style={{ margin: '5px' }}>
          <TextareaAutosize 
            id="plan" 
            name="plan" 
            type="text" 
            className="form-control custom-textarea" 
            placeholder="Plan" 
            onChange={e => handleOnchange(e)}
            value={plan}
            disabled={isDisabled}
            minRows={2} />
          {!isDisabled && (
            <i 
              className="fal fa-times clear-textarea text-danger"
              onClick={() => handleClear('plan')} 
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default PlanTextComponent;
